import {startLoading, setUserOrganization} from "./userOrganizationSlice";
import axios from "axios";
import {zynity_api} from "../../config/external-routes";

export const getUserOrganizations = () => {
    return async (dispatch: (arg0: { payload: any; type: string; }) => void, state: any) => {
        dispatch(startLoading())

        console.log("calling again?")

        const user = state().auth
        axios.defaults.headers.common = {
            'Authorization': `Bearer ${user.access_token}`
        }

        console.log('[THUNK] Using access token:', user.access_token);

        axios.get(
            zynity_api.get_user_organization_light.replace('{user_id}', user.id),
            {
                headers: {
                    Authorization: `Bearer ${user.access_token}`
                }
            }
        ).then((response) => {
            dispatch(setUserOrganization(response.data))
        }).catch((err) => {
            console.error('Light org error', err);
        });
        
        axios.get(
            zynity_api.get_user_organization.replace('{user_id}', user.id),
            {
                headers: {
                    Authorization: `Bearer ${user.access_token}`
                }
            }
        ).then((response) => {
            dispatch(setUserOrganization(response.data))
        }).catch((err) => {
            console.error('Full org error', err);
        });
        
    }
}
